export const SET_PROGRESS_PAGE_DATA = 'SET_PROGRESS_PAGE_DATA';
export const START_FETCH_PROGRESS_PAGE_DATA = 'START_FETCH_PROGRESS_PAGE_DATA';
